import { AuthService } from '@/utils/service'
export const sendDeviceTrack = (eventId, applyId, eventName, eventValue, eventParameter, platform, os, requestHref, appName, appCodeName, appVersion, osVersion, browserVersion, wxVersion, netType, deviceType, trueIp, latitude, longitude, deviceId, language, tokenId, gpsFailReason) => {
  return new AuthService({
    url: '/api/tracking',
    method: 'post',
    data: {
      eventId,
      applyId,
      eventName,
      eventValue,
      eventParameter: JSON.stringify(eventParameter),
      platform,
      os,
      requestHref,
      appName,
      appCodeName,
      appVersion,
      osVersion,
      browserVersion,
      wxVersion,
      netType,
      deviceType,
      trueIp,
      latitude,
      longitude,
      deviceId,
      language,
      tokenId,
      gpsFailReason,
      productId: "DM-QBXJ"
    }
  })
}

